import styled from 'styled-components';

export const TableContainer = styled.div`
  flex: 1;
  width: 100%;

  overflow-y: auto;
`;

export const ColumnsRow = styled.div`
  width: 100%;
  height: 40px;
  padding: 0 24px;

  display: flex;
  align-items: center;

  border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
`;

export const ProductRow = styled.div`
  position: relative;

  width: 100%;
  min-height: 64px;
  padding: 12px 24px;

  display: flex;
  align-items: center;

  border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
`;

/** Dot flagging an undelivered line, sitting in the left padding of its row */
export const MissingReferenceDot = styled.div`
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);

  width: 16px;
  height: 16px;

  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.infoOrange};

  background-size: 8px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('/images/inpulse/close-white-small.svg');
`;

export const Cell = styled.div`
  flex: ${({ flex }) => flex};
  min-width: 0;

  display: flex;
  align-items: center;
  column-gap: 12px;
`;
